import React from "react";
import './SimpleButton.css';

export default class Button extends React.Component{
  render(){
    var _class = `${this.props.classes} pure-button button-large simples-button`;
    return(
      <button
        onClick={this.props.onClick}
        type={this.props.type}
        className={_class}
        disabled={this.props.disabled}
      >
       {this.props.text}
     </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/Button.js